import { CircleHelp } from 'lucide-react';
import { Button } from '../Button/Button';
import { ReusableTooltip } from '../ui/ReusableTooltip';

const ProgressBar = ({
  count,
  maxCount,
  label,
  tooltipLabel,
}: {
  count: number;
  maxCount: number;
  label: string;
  tooltipLabel: string;
  tooltipId: string;
}) => {
  return (
    <div>
      <div className="w-full flex flex-row justify-between items-center mb-0.5">
        <label
          className="text-sm text-primary flex flex-row items-center leading-[22px]"
          htmlFor="monthlyCredits"
        >
          <p>{label}</p>

          <ReusableTooltip position="top" content={tooltipLabel}>
            <Button
              size="xs"
              variant="ghost"
              className="hover:bg-transparent h-3 pl-1.5"
            >
              <CircleHelp className="text-foreground" size={12} />
            </Button>
          </ReusableTooltip>
        </label>
        <div className="text-xs text-foreground/50 font-medium">
          <span>
            {count && count > maxCount ? maxCount : count ? count : 0}
          </span>
          <span className="text-foreground/50">/{maxCount}</span>
        </div>
      </div>
      <div className="rounded-lg overflow-hidden bg-popover-hover h-1 cursor-default">
        <div
          className="bg-[#D0D0D0]  h-full rounded-full"
          style={{
            width: count > 0 ? `${(count / maxCount) * 100}%` : '0%',
          }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
